<template>
	<div class="px-5">
		<app-table
			class="mt-3 is-not-selectable no-main-list"
			name="apps-users"
			:columns="columns"
			:rows="rows"
			:input-search="false"
			:main-list="false"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.app.data.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.role.data.name }}
				</td>
				<td>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar"
						@click-icon="deleteRole(props.row.id)"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function deleteRole(value) {
	this.$emit('delete-role', value);
}

export default {
	name: 'apps-users-list',
	props: {
		columns: {
			type: Array,
			required: true,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	components: {
		appTooltipButton,
	},
	methods: {
		deleteRole,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/app-user-list.vue